module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_privacy_m_en.38f8207842003ec595fd333f1e064556.png";